<template>
  <div v-if="getAgent">
    <v-form lazy-validation>
      <v-row class="text-left py-2">
        <v-col cols="12" class="pb-0">
          <v-row class="mb-2">
            <v-col cols="6" class="py-0">
              <label for="etiqueta">Etiqueta</label>
            </v-col>
            <v-col cols="6" class="pa-0">
              <TagModal />
            </v-col>
          </v-row>
          <v-combobox
            id="etiqueta"
            v-model="tags"
            :items="getActiveTags"
            chips
            multiple
            class="h-auto pt-0"
            item-id="name"
            item-text="name"
            return-object
            solo
            hide-details
            @focus="comboboxOpen = true"
            @blur="comboboxOpen = false"
          >
            <template #selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                :color="item.color"
                @click="select"
                @click:close="removeTag(item)"
              >
                <strong>{{ item.name }}</strong>
                &nbsp;
                <span />
              </v-chip>
            </template>

            <template #no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    El tag no existe. Presiona
                    <kbd>enter</kbd>
                    para crearlo.
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TagModal from "@/components/modals/TagModal";
import getRandomColor from "@/helpers/get_randomcolor";
export default {
  components: { TagModal },
  data() {
    return { tags: [], loadSaveTags: false, comboboxOpen: false };
  },
  computed: {
    ...mapGetters(["getAgent", "getActiveTags", "getTicket", "getTags"]),
  },
  watch: {
    comboboxOpen(value) {
      if (!value) this.changeTags();
    },
    getTicket(value, oldValue) {
      if (JSON.stringify(value.tags || []) !== JSON.stringify(oldValue.tags || []))
        this.tags = this.setTags(value.tags);
    },
  },
  async mounted() {
    if (!this.getTags) await this.getAllTags();

    if (!this.loadSaveTags) this.resetTicketTags();
  },
  methods: {
    ...mapActions(["createTag", "updateTicket", "getAllTags", "updateTag"]),
    resetTicketTags() {
      this.tags = this.setTags(this.getTicket.tags) || [];
    },
    changeTags(e) {
      if (e && e.length > 0) {
        let last = e[e.length - 1];
        if (!last.color) this.tags[e.length - 1] = { id: last, name: last, color: getRandomColor(), active: true };
      }

      const ticketTags = this.getTicket.tags || [];
      const currentTags = this.tags || [];

      const tagsChanges =
        ticketTags.length === currentTags.length &&
        ticketTags.every((ticketTag) => currentTags.some((currentTag) => currentTag.id === ticketTag));

      if (!tagsChanges) this.saveTags();
    },

    removeTag(item) {
      this.tags.splice(this.tags.indexOf(item), 1);
      this.tags = [...this.tags];
    },

    setTags(tags) {
      let formattedTags = [];

      if (this.getTags && tags) {
        for (let i = 0; i < tags.length; i++) {
          let ind = this.getTags.findIndex((item) => item.id == tags[i]);
          formattedTags.push(this.getTags[ind]);
        }
      }

      return formattedTags;
    },
    cancelTags(tags) {
      this.tags = this.setTags(tags || this.getTicket.tags);
    },

    async saveTags() {
      try {
        this.loadSaveTags = true;

        let tagsToSave = [],
          auxTag,
          isRepeated,
          promises = [];

        for (let i = 0; i < this.tags.length; i++) {
          auxTag = Object.assign({}, this.tags[i]);
          isRepeated = this.getTags.find((item) => {
            return item.name === auxTag.name && item.active;
          });

          if (isRepeated) tagsToSave.push(auxTag.id);
          else promises.push(this.createTag({ tag: auxTag }));
        }

        let createdTag = await Promise.all(promises);
        tagsToSave.push(...createdTag);

        if (!this.comboboxOpen) {
          const response = await this.updateTicket({ ticket_id: this.getTicket.id, data: { tags: tagsToSave } });
          if (response) this.cancelTags(tagsToSave);
        }
      } catch (error) {
        console.error("ticket/saveTags: ", error);
        this.resetTicketTags();
      } finally {
        this.loadSaveTags = false;
      }
    },
  },
};
</script>
